import { render, staticRenderFns } from "./aproveService.vue?vue&type=template&id=2b4a0022&scoped=true"
import script from "./aproveService.vue?vue&type=script&lang=js"
export * from "./aproveService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a0022",
  null
  
)

export default component.exports